import React from 'react';

const LoadingSpinner = () => (
  <div className="loader">Loading...</div>
);

export default LoadingSpinner;
